module.exports = __webpack_public_path__ + "img/中原@2x.c37e4630.png";